<template>
  <div
    class="w-imbee-container"
    :style="{ backgroundColor: chat.backgroundColor }"
  >
    <transition
      name="imbee-fadeIn"
      enter-active-class="imbee-fadeInDown"
      leave-active-class="imbee-fadeOutUp"
    >
      <Header
        @close="close()"
        v-show="header.show"
        :full-screen="fullScreen"
        :text="header.text"
        :image="header.image"
        :show-image="header.showImage"
        :color="header.color"
        :font-size="header.fontSize"
        :font-family="header.fontFamily"
        :font-weight="header.fontWeight"
        :background-color="header.backgroundColor"
        :header-top="header.headerTop"
        :header-left="header.headerLeft"
        :subtitle-text="header.subtitleText"
        :subtitle-color="header.subtitleColor"
        :font-subtitle-size="header.fontSubtitleSize"
        :font-subtitle-weight="header.fontSubtitleWeight"
        :font-subtitle-family="header.fontSubtitleFamily"
        :image-size="header.imageSize"
        :subtitle-top="header.subtitleTop"
        :subtitle-left="header.subtitleLeft"
      />
    </transition>
    <LoaderContainer
      v-if="loader.show"
      :loader="loader.type"
      :loader-color="loader.color"
      :loader-background="loader.backgroundColor"
    />
    <Content v-show="!loader.show" :fs="footer.show"/>
      <Cookie-banner v-show="cookieBanner.show" :cookieData="cookieBanner" v-on:closeCookieBanner="closeCookieBanner" />
    <transition
      name="imbee-fadeIn"
      enter-active-class="imbee-fadeInUp"
      leave-active-class="imbee-fadeOutDown"
    >
      <Footer v-show="footer.show" />
    </transition>
    <ContentHumanizacion />
  </div>
</template>

<script>
import Header from "./Header";
import Content from "./Content";
import ContentHumanizacion from "./ContentHumanizacion";
import CookieBanner from "./CookieBanner";
import Footer from "./Footer";
import LoaderContainer from "./LoaderContainer";

export default {
  name: "Container",
  components: {
    Header,
    Content,
    CookieBanner,
    Footer,
    ContentHumanizacion,
    LoaderContainer,
  },
  props: {
    header: { type: Object, default: {} },
    loader: { type: Object, default: {} },
    cookieBanner: { type: Object, default: () => ({
            backgroundColorTransparent:"",
            backgroundColor:"",
            shadowColor:"",
            textColor:"",
            separatorColor:"",
            buttonBackgroundColor:"",
            buttonBorderColor:"",
            buttonTextColor:"",
            buttonHoverBackgroundColor:"",
            buttonHoverBorderColor:"",
            buttonHoverTextColor:"",
            highlightedButtonBackgroundColor:"",
            highlightedButtonBorderColor:"",
            highlightedButtonTextColor:"",
            highlightedButtonHoverBackgroundColor:"",
            highlightedButtonHoverBorderColor:"",
            highlightedButtonHoverTextColor:"",
        }) },
    footer: { type: Object, default: {} },
    chat: { type: Object, default: {} },
    fullScreen: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
      closeCookieBanner() {
        this.cookieBanner.show = false
      },
  },
  computed: {},
};
</script>

<style scoped>
.w-imbee-container {
  position: absolute;
  right: 0;
  bottom: 80px;
  height: 100%;
  width: 100%;
  border-radius: 12px;
  display: -webkit-box; 
  display: -moz-box; 
  display: -ms-flexbox; 
  display: -webkit-flex; 
  display: flex; 
  flex-direction: column;
  box-shadow: 0 20px 60px 0px rgba(120, 120, 120, 0.2),
    0px 0px 25px 10px rgba(180, 180, 180, 0.15);
  overflow: hidden;
}

@media screen and (max-width: 568px) {
  .w-imbee-container {
    border-radius: 0;
    bottom: 0 !important;
    left: initial !important;
    max-height: 100% !important;
    height: 100% !important;
    right: 0 !important;
    top: initial !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow: hidden !important;
  }
}
</style>


// WEBPACK FOOTER //
// Container.vue?2159f3d7